import { render, staticRenderFns } from "./SubfactorView.vue?vue&type=template&id=5ca3284c&scoped=true&"
import script from "./SubfactorView.vue?vue&type=script&lang=js&"
export * from "./SubfactorView.vue?vue&type=script&lang=js&"
import style0 from "./SubfactorView.vue?vue&type=style&index=0&id=5ca3284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3284c",
  null
  
)

export default component.exports